<template>
    <div class="max-md:container flex">
        <div class="flex flex-col-reverse items-start mt-5 mb-7 relative w-full md:flex-col md:mt-7 md:mb-9">
            <div
                v-if="profile"
                class="flex flex-col w-full"
            >
                <div class="flex flex-wrap-reverse items-center gap-y-6">
                    <div class="flex items-center w-fit">
                        <div class="flex flex-col items-center mr-4 md:mr-6">
                            <UserAvatar
                                v-if="profile && profilePictureLazyLoad"
                                :animated-avatar="profile.gamify_avatar_url"
                                :picture="profilePictureLazyLoad.src"
                                :show-details="false"
                                :size="'profile'"
                                class="profile-picture-container bg-cover bg-no-repeat rounded-full flex-shrink-0"
                            ></UserAvatar>
                            <div
                                v-if="profile.hasAdminBadge"
                                class="justify-center absolute h-3 z-[9] -bottom-[0.5rem] px-1 bg-blue-600 rounded leading-3 text-center text-3xs text-slate-50"
                            >
                                {{ t('admin')?.toUpperCase() }}
                            </div>
                        </div>
                        <h1
                            class="font-display-3 lg:font-display-2 line-clamp-2 mr-2"
                            style="word-break: break-word !important"
                            v-text="profile.name"
                        ></h1>
                    </div>
                    <ProfileShowMenu class="w-full md:w-fit ml-auto mr-0 justify-end" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { useTranslation } from 'i18next-vue';
import ProfileShowMenu from './ProfileShowMenu.vue';

export default {
    name: 'ProfileShowHeader',
    components: {
        ProfileShowMenu,
    },
    setup() {
        const { t } = useTranslation('profile');
        return { t };
    },
    data() {
        return {
            profilePictureLazyLoad: null,
        };
    },
    computed: {
        ...mapGetters({
            profile: 'profile/profile',
        }),
    },
    mounted() {
        this.$nextTick(() => {
            this.profilePictureLazyLoad = {
                src: this.profile.image.url_big || this.profile.image.avatar.url_big,
                error: this.profile.image.avatar.url_big,
                loading: '/images/spinners/loading_preview.svg',
            };
        });
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
.profile-picture-container {
    flex-basis: 64px;

    @screen md {
        flex-basis: 88px;
    }
}
</style>
